import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.28236 6.92331C2.17315 6.03842 2.79887 4.25073 4.21781 4.25073H17.7699C18.9218 4.25073 19.6438 5.49518 19.0721 6.49517L12.4397 18.0971C11.7465 19.3098 9.91775 19 9.66268 17.6266L8.58003 11.7976L12.8708 9.35826C13.2309 9.15355 13.3568 8.69568 13.1521 8.33559C12.9474 7.97551 12.4895 7.84955 12.1294 8.05427L7.79142 10.5205L3.28236 6.92331Z",
  fill: "currentColor",
  "fill-opacity": "0.8824"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }